package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.SteamSimpleIcons: ImageVector
    get() {
        if (_steamSimpleIcons != null) {
            return _steamSimpleIcons!!
        }
        _steamSimpleIcons = Builder(name = "SteamSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(11.98f, 0.0f)
                curveTo(5.68f, 0.0f, 0.51f, 4.86f, 0.02f, 11.04f)
                lineToRelative(6.43f, 2.66f)
                curveToRelative(0.55f, -0.37f, 1.20f, -0.59f, 1.91f, -0.59f)
                curveToRelative(0.06f, 0.0f, 0.13f, 0.00f, 0.19f, 0.01f)
                lineToRelative(2.86f, -4.14f)
                lineTo(11.42f, 8.91f)
                curveToRelative(0.0f, -2.50f, 2.03f, -4.52f, 4.52f, -4.52f)
                curveToRelative(2.49f, 0.0f, 4.52f, 2.03f, 4.52f, 4.53f)
                reflectiveCurveToRelative(-2.03f, 4.53f, -4.52f, 4.53f)
                horizontalLineToRelative(-0.11f)
                lineToRelative(-4.08f, 2.91f)
                curveToRelative(0.0f, 0.05f, 0.00f, 0.11f, 0.00f, 0.16f)
                curveToRelative(0.0f, 1.88f, -1.52f, 3.40f, -3.39f, 3.40f)
                curveToRelative(-1.64f, 0.0f, -3.02f, -1.17f, -3.33f, -2.73f)
                lineTo(0.44f, 15.27f)
                curveTo(1.86f, 20.31f, 6.49f, 24.0f, 11.98f, 24.0f)
                curveToRelative(6.63f, 0.0f, 12.00f, -5.37f, 12.00f, -12.0f)
                reflectiveCurveTo(18.61f, 0.0f, 11.98f, 0.0f)
                close()
                moveTo(7.54f, 18.21f)
                lineToRelative(-1.47f, -0.61f)
                curveToRelative(0.26f, 0.54f, 0.71f, 1.00f, 1.31f, 1.25f)
                curveToRelative(1.30f, 0.54f, 2.79f, -0.08f, 3.33f, -1.38f)
                curveToRelative(0.26f, -0.63f, 0.26f, -1.32f, 0.01f, -1.95f)
                reflectiveCurveToRelative(-0.75f, -1.12f, -1.38f, -1.38f)
                curveToRelative(-0.62f, -0.26f, -1.29f, -0.25f, -1.88f, -0.03f)
                lineToRelative(1.52f, 0.63f)
                curveToRelative(0.96f, 0.4f, 1.41f, 1.5f, 1.01f, 2.46f)
                curveToRelative(-0.40f, 0.96f, -1.50f, 1.41f, -2.45f, 1.01f)
                lineTo(7.54f, 18.21f)
                close()
                moveTo(18.96f, 8.91f)
                curveToRelative(0.0f, -1.66f, -1.35f, -3.02f, -3.02f, -3.02f)
                curveToRelative(-1.67f, 0.0f, -3.02f, 1.35f, -3.02f, 3.02f)
                curveToRelative(0.0f, 1.67f, 1.35f, 3.02f, 3.02f, 3.02f)
                curveToRelative(1.66f, 0.0f, 3.02f, -1.35f, 3.02f, -3.02f)
                close()
                moveTo(13.68f, 8.90f)
                curveToRelative(0.0f, -1.25f, 1.01f, -2.27f, 2.27f, -2.27f)
                curveToRelative(1.25f, 0.0f, 2.27f, 1.01f, 2.27f, 2.27f)
                curveToRelative(0.0f, 1.25f, -1.02f, 2.27f, -2.27f, 2.27f)
                curveToRelative(-1.25f, 0.0f, -2.27f, -1.01f, -2.27f, -2.27f)
                close()
            }
        }
        .build()
        return _steamSimpleIcons!!
    }

private var _steamSimpleIcons: ImageVector? = null
